import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@Router/routes.tsx';
import {
  ObservabilityErrorSeverity,
  reportError,
} from '@Services/observability/initObservability.ts';
import { WelcomePage } from '@Pages/passwordless/welcome/WelcomePage.tsx';
import { queryClient } from '../queryClient.ts';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultNotFoundComponent: () => <WelcomePage />,
  defaultOnCatch(error) {
    const errorToReport = {
      metadata: {
        name: error.name,
        message: error.message,
      },
      severity: ObservabilityErrorSeverity.ERROR,
    };
    reportError(errorToReport);
  },
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});
